import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Input,
  Flex,
  Button,
  Stack,
  Text,
  Spinner,
} from '@chakra-ui/react';
import { Card, CardBody, CardHeader } from '@chakra-ui/react';

const CustomerSearchModal = ({
  isOpen,
  closeSearchClientModal,
  handleCustomerSearch,
  customerSearch,
  setCustomerSearch,
  isSearchingCustomer,
  customersList,
  handleSelectCustomer,
  handleAddCustomer,
  searchCompleted,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={closeSearchClientModal} isCentered closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent maxW="md" p={4}>
        <ModalHeader textAlign="center">Búsqueda de Cliente</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Input
            placeholder="Ingrese el nombre del cliente"
            value={customerSearch}
            onChange={(e) => setCustomerSearch(e.target.value)}
            onKeyDown={handleCustomerSearch}
            mb={4}
          />
          {isSearchingCustomer ? (
            <Flex justify="center" align="center" h="100px">
              <Spinner size="lg" />
            </Flex>
          ) : customersList.length > 0 ? (
            <Stack spacing={4}>
              {customersList.map((customer) => (
                <Card
                  key={customer.id}
                  borderRadius="md"
                  boxShadow="lg"
                  _hover={{ bg: 'gray.100', cursor: 'pointer' }}
                  onClick={() => handleSelectCustomer(customer)}
                >
                  <CardHeader fontSize="lg" fontWeight="bold">
                    {customer.name}
                  </CardHeader>
                  <CardBody>
                    <Text>Documento: {customer.document}</Text>
                    <Text fontSize="sm" color="gray.600">
                      Ubicación: {
                        customer.locality?.department?.country?.name &&
                        customer.locality?.department?.name &&
                        customer.locality?.name
                          ? `${customer.locality.department.country.name} - ${customer.locality.department.name} - ${customer.locality.name}`
                          : customer.locality?.name || 'No disponible'
                      }
                    </Text>
                  </CardBody>
                </Card>
              ))}
            </Stack>
          ) : searchCompleted ? (
            <Flex direction="column" align="center" mt={4}>
              <Text>No se encontraron clientes.</Text>
            </Flex>
          ) : null}
          <Flex direction="column" align="center" mt={4}>
            <Button mt={2} variant="adminPrimary" onClick={handleAddCustomer}>
              Nuevo Cliente
            </Button>
          </Flex>
        </ModalBody>
        <ModalFooter justifyContent="center">
          <Button colorScheme="gray" onClick={closeSearchClientModal}>
            Cancelar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default CustomerSearchModal;
